/**
 * HTTP API contracts shared by frontend and backend.
 *
 * These types are the single source of truth for the wire format. The backend
 * returns them, the frontend consumes them - a mismatch is a compile error
 * instead of a runtime surprise.
 */
export const API_ERROR_CODES = [
    'unauthenticated',
    'forbidden',
    'invalid_request',
    'unsupported_media_type',
    'payload_too_large',
    'not_found',
    'conflict',
    'rate_limited',
    'dependency_unavailable',
    'internal_error',
];
export const DEPENDENCY_NAMES = ['cosmos', 'blobStorage', 'work4all'];
export const DEPENDENCY_STATUSES = ['ok', 'degraded', 'unavailable', 'not_configured'];
/** Route table, so the frontend never hardcodes a path string twice. */
export const API_ROUTES = {
    health: '/api/health',
    me: '/api/me',
    settings: '/api/settings',
    status: '/api/status',
    answers: '/api/answers',
    customers: '/api/customers',
    customerLocations: (customerId) => `/api/customers/${customerId}/locations`,
    customerTechnicalObjects: (customerId) => `/api/customers/${customerId}/technical-objects`,
    /** Base of the series endpoints; the import is `POST <base>/import`. */
    customerMeasurementSeries: (customerId) => `/api/customers/${customerId}/measurement-series`,
    /** Base of the plan endpoints; a plan is `<base>/{planId}`, its image `<base>/{planId}/image`. */
    customerFloorPlans: (customerId) => `/api/customers/${customerId}/floor-plans`,
    /** Base of the document endpoints; a document is `<base>/{documentId}`. */
    customerDocuments: (customerId) => `/api/customers/${customerId}/documents`,
    customerDocumentTypes: (customerId) => `/api/customers/${customerId}/document-types`,
};
//# sourceMappingURL=contracts.js.map